import { handlePrice } from '../../../utils/utils';
import { View } from '../../base/View';
import { AppStateComponents, SETTINGS } from '../../../utils/constants';
export class BasketView extends View {
    // Конструктор принимает имя блока, родительский элемент и обработчик событий
    constructor(container, events) {
        super(container);
        this.events = events;
        this._button = container.querySelector(SETTINGS.basketSettings.button);
        this._total = container.querySelector(SETTINGS.basketSettings.total);
        this._list = container.querySelector(SETTINGS.basketSettings.list);
        if (this._button)
            this._button.addEventListener('click', () => this.events.emit(AppStateComponents.BASKET.ORDER));
    }
    // Сеттер для общей цены
    set total(price) {
        this._total.textContent = handlePrice(price) + ' синапсов';
    }
    // Сеттер для списка товаров
    set list(items) {
        this._list.replaceChildren(...items);
        this._button.disabled = items.length ? false : true;
    }
    // Метод отключающий кнопку "Оформить"
    disableButton() {
        this._button.disabled = true;
    }
    // Метод для обновления индексов таблички при удалении товара из корзины
    refreshIndices() {
        Array.from(this._list.children).forEach((item, index) => (item.querySelector(SETTINGS.productBasketSettings.id).textContent = (index + 1).toString()));
    }
}
